import classnames from 'classnames'

import { formatDate } from '../../../../app/header/utils'
import { RedGreenMultiline, RedGreenText } from '../../../components/RedGreenText'
import { formatNumber } from '../../../util'

export interface QuotePriceProps {
  title?: string
  date?: Date | null
  dateLabel?: string | null
  price: number
  changeUsd: number
  changePct: number
}

export function QuotePrice({ title, date, dateLabel, price, changeUsd, changePct }: QuotePriceProps) {
  const fractions = !isNaN(price) && price < 1 ? 4 : 2
  const hasValue = changeUsd && Number.isFinite(changeUsd)

  return (
    <div className="quote-price">
      {title && <div className="sr-only">{title}</div>}

      {(date || dateLabel) && (
        <span className="quote-price_date">
          {dateLabel ?? formatDate(date, '', 'MMM dd')}
          {date && (
            <>
              {' '}
              <span className="text-muted-3">•</span> {formatDate(date, '', 'hh:mmaa')} ET
            </>
          )}
        </span>
      )}

      <div className="quote-price_wrapper">
        <strong className="quote-price_wrapper_price">{formatNumber(price, { defaultValue: '—', fractions })}</strong>
        <div className="quote-price_wrapper_change">
          <RedGreenMultiline>
            <RedGreenText value={changeUsd} className={classnames({ 'text-muted-2': !hasValue })}>
              <div className="sr-only">Dollar change</div>
              {formatNumber(changeUsd, { showPlusSign: true, fractions })}
            </RedGreenText>
            <RedGreenText
              value={changePct}
              className={classnames({ 'text-muted-2': !hasValue })}
              rightContent={<span className="font-normal">%</span>}
            >
              <div className="sr-only">Percentage change</div>
              {formatNumber(changePct)}
            </RedGreenText>
          </RedGreenMultiline>
        </div>
      </div>
    </div>
  )
}
